export default {
  Login: 'Login',
  Sign_up: 'Sign up',
  Feedback: 'Feedback',
  Settings: 'Settings',
  Log_out: 'Log out',
  mo: 'mo',
  Total: 'Total',
  header: {
    download: 'Download ios App/extension'
  }

}
